import React, { Component } from "react";
import FormField from "../FormField";
import CurrencyInput from "src/shared/CurrencyInput";

export default class PayoutPennies extends Component {
  render() {
    const { name, ...rest } = this.props;

    return (
      <FormField name={name || "payout_pennies"} label="Payout">
        <CurrencyInput data-cy="influencer-payout" {...rest} />
      </FormField>
    );
  }
}
